import {
    UIListener,
    ComponentManager,
    DetailViewContext, MessageBoxViewModel, RADApplication,
    LabelViewModel, ListViewViewModel, CustomFilterChipBuilder, ResourceManager
} from 'radpresentation.htmlclient.defaultviewextensions';
import {IListViewDTO, IOperationResultDTO} from 'coreframetypings/dto';
import UIListenerUtility from '@/Utils/UIListenerUtility';

class KursUIListener extends UIListener
{
    readonly #ArchiveMethodName = 'Archive';
    readonly #NichtArchiviertErgName = 'ONV.ONV.KURS_FILTER_AKTUELLE_ERGNAME';
    readonly #NichtArchiviertFilterStatement = 'this.Archivstatus = \'NichtArchiviert\'';

    LabelViewModel = ComponentManager.getViewModel<LabelViewModel>('LabelViewModel');

    public override onBeforeListViewRender(context: ListViewViewModel, dto: IListViewDTO) {
        this.addNichtArchiviertDefaultChip(context);
    }

    public override onDetailViewReady(context: DetailViewContext)
    {
        UIListenerUtility.hideControlViaOtherControl(context, 'IsOnline', 'Ort', (value) => !value);
        this.makeReadonly(context);
    }

    public override onAfterApply(context: DetailViewContext, isClosing: boolean)
    {
        this.makeReadonly(context);
    }

    public onAfterCallOperation(context: DetailViewContext, operation: string, args: IOperationResultDTO) {
        super.onAfterCallOperation(context, operation, args);
        
        if (operation === this.#ArchiveMethodName)
        {
            if (args.isValid)
                context.apply();
        }
    }

    public onBeforeCallOperation(context: DetailViewContext,
                                 operation: string): boolean | JQueryDeferred<boolean> | JQueryPromise<boolean>
    {
        if (operation === this.#ArchiveMethodName)
        {
            let result = $.Deferred();
            let msgVM = MessageBoxViewModel.createOkayCancelMessageBox(
                null,
                'ONV.ONV.KURS_ARCHIVE_WARNING_MESSAGE',
                () => { result.resolve(true); },
                () => { result.resolve(false); },
                '.YesNoMessageBox');

            msgVM.window.headline = new this.LabelViewModel({ ergName: 'USER_ANONYMIZE_MESSAGE_TITLE' });

            RADApplication.getInstance().showMessageBox(msgVM);
            return result;
        }

        return super.onBeforeCallOperation(context, operation);
    }

    private makeReadonly(context: DetailViewContext) {
        const status = context.genericObject.getValue('Archivstatus.Value') as string;
        if (status && status === 'Archiviert')
        {
            UIListenerUtility.makeEverythingReadonly(context);
            context.toolBar.getElementByMethodName(this.#ArchiveMethodName).isEnabled(false);
        }
    }
    
    private addNichtArchiviertDefaultChip(context: ListViewViewModel): void {
        const displayName = ResourceManager.getInstance().get(this.#NichtArchiviertErgName);

        if (context.customFilterChips().some(chip => chip.displayName === displayName))
        {
            return;
        }

        const chip = new CustomFilterChipBuilder(displayName)
            .useFilterStatement(this.#NichtArchiviertFilterStatement)
            .isActiveOnOpen(true)
            .build();

        context.appendCustomFilterChip(chip);
    }
}

ComponentManager.setUIListener('KursUIListener', KursUIListener, 'ONVHTMLViewExtension');